// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"478":"organization","594":"about"}[chunkId] + "." + {"478":"775420d8","594":"60046446"}[chunkId] + ".css";
};